import {
  CalendarEventDetails,
  CalendarEventGuest,
  ExternalConnectionsProviders,
} from '@griply/types';

export type ShouldAskGuestNotificationOptions = {
  provider?: ExternalConnectionsProviders;
  guests: CalendarEventGuest[];
  organizer?: CalendarEventDetails['organizer'];
};

export const shouldAskGuestNotification = ({
  provider,
  guests,
  organizer,
}: ShouldAskGuestNotificationOptions): boolean => {
  if (provider !== ExternalConnectionsProviders.Google) {
    return false;
  }

  const organizerEmail = organizer?.email.toLowerCase();

  return guests.some(({ email }) => email.toLowerCase() !== organizerEmail);
};
